/**
 * alert Group
 * @param fb : FormBuilder
 */
export function alertGroup (fb: any):any {
    return fb.group({
        category: fb.control([]),
        hasAlert: fb.control('')

    });
}
